<template>
  <span v-if="clientInfo">
    {{clientInfo.title}}
  </span>
  <span v-else>{{clientId}}</span>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'client-short-info',
        components: {},
        props: {
            clientId: {
                type: String,
                required: true
            },
        },
        data() {
            return {}
        },
        computed: {
            ...mapState({availableClients: 'availableClients'}),
            clientInfo() {
                let client =_.find(this.availableClients, c => c.id === this.clientId)
                return client
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/mcc/ClientShortInfo.vue